(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.service('creativeApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.delete = function(creativeId) {
        var url = '/demandmgr/creative?id=' + creativeId;

        return $q(function(resolve, reject) {
          $http.delete(url).then(
            // success
            function() {
              resolve();
            },
            // error
            function() {
              reject();
            }
          );
        });
      };

      this.save = function(creative) {
        var url = '/demandmgr/creative/save';

        return $q(function(resolve, reject) {
          $http.post(url, creative).then(
            // success
            function(res) {
                if (res.data.status === 'success') {
                    resolve();
                } else {
                    reject(res.data);
                }
            },
            // error
            function() {
              reject();
            }
          );
        });
      };

       this.read = function(creativeId) {
        var url = '/demandmgr/creative/read?id=' + creativeId;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };

        this.checkContent = function(creativeType, content) {
            var url = '/demandmgr/creative/checkContent';

            return $q(function(resolve, reject) {
                $http.post(url, {
                    creativeType: creativeType,
                    content: content
                }).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function() {
                        reject();
                    }
                );
            });
        };

      this.generateSSPXRedirectorCode = function(adId, adtype, bidder, deal) {
          var url = '/demandmgr/creative/generateSSPXRedirectorCode';
          return $q(function(resolve, reject) {
              $http.post(url, {
                  adid: adId,
                  adtype: adtype,
                  bidder: bidder,
                  deal: deal,
              }).then(
                  // success
                  function(res) {
                      resolve(res.data);
                  },
                  // error
                  function() {
                      reject();
                  }
              );
          });
      };


      this.isCreativeNameUnique = function(
        advertiserId,
        creativeName,
        creativeId
      ) {
        var url =
          '/demandmgr/creative/check-name?advertiserId=' +
          advertiserId +
          '&id=' +
          creativeId +
          '&name=' +
          creativeName;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function() {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
